import { Component } from '@angular/core';
import { WizardPageComponent } from '../../../../wizard/wizard-page-component';
import type { StoreExportWizard } from '../store-export-wizard';
import { StoreExportService } from '../../../store-export.service';
import { Observable } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';

@Component({
  standalone: false,
  selector: 'mtn-store-export-page',
  templateUrl: './store-export-page.component.html',
  styleUrls: ['./store-export-page.component.scss']
})
export class StoreExportPageComponent extends WizardPageComponent<StoreExportWizard> {

  key = 'store-export';

  constructor(private storeExportService: StoreExportService, private hitTrackingService: HitTrackingService) {
    super();
    this.title = 'Export Store Data';
    this.nextButtonText = 'Export';
    this.closeButtonText = 'Cancel';
  }

  onLoad(): Observable<any> {
    this.initForm();
    return super.onLoad();
  }

  onNext(): Observable<string> {
    const formValue = this.form.getRawValue();
    const uuidCount = this.wizard.model.uuids?.length || 0;
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.STORE_EXPORT_WIZARD,
      {
        actionType: 'export',
        storeCount: uuidCount,
        includeRatings: formValue.includeRatings,
        includeServices: formValue.includeServices
      },
      USER_TRACKING_ACTIONS.EXPORT_STORES,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.EXPORT_STORES](
        uuidCount,
        formValue.includeRatings,
        formValue.includeServices
      )
    ).subscribe();


    return this.storeExportService.exportAsCsv(this.wizard.model.uuids, formValue.includeRatings, formValue.includeServices)
      .pipe(map(() => null));
  }

  private initForm(): void {
    this.form = new UntypedFormGroup({
      includeRatings: new UntypedFormControl(false),
      includeServices: new UntypedFormControl(false)
    });
  }

}
